import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  collapsible: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(0.5, 0.5, 0.5, 0),
  },
  graph: {
    gridRow: 2,
    width: '100%',
    gridColumnStart: 1,
    gridColumnEnd: 3,
  },
}));

export default useStyles;
